"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

require('./chunk-NESC3UD7.js');

require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

var _jsxruntime = require('react/jsx-runtime');

var m = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "FacebookIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M20.2136 16.375L20.8359 12.3935H16.9452V9.8098C16.9452 8.72055 17.4887 7.65879 19.2312 7.65879H21V4.26898C21 4.26898 19.3949 4 17.8602 4C14.656 4 12.5617 5.90695 12.5617 9.35906V12.3935H9V16.375H12.5617V26H16.9452V16.375H20.2136Z"
  }),
  svgElements: ["path"]
});

exports.FacebookIconMedium = m;